import { render, staticRenderFns } from "./XHeader.vue?vue&type=template&id=14c47440&scoped=true"
var script = {}
import style0 from "./XHeader.vue?vue&type=style&index=0&id=14c47440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c47440",
  null
  
)

export default component.exports